import { useDebounce } from '@insify/react-hooks';
import { useEffect, useState } from 'react';

import { useCompanySearchQuery } from '../../hooks/useQueries';

import type { RegisteredCompany } from '../../models/company';

const DEBOUNCE_TIME = 300;

export const mapCompanyToId = ({ id, name }: RegisteredCompany): string => `${id.value}-${name}`;

export const useCompanySearch = (searchString: string) => {
  const debouncedSearchString = useDebounce(searchString, DEBOUNCE_TIME);
  const [results, setResults] = useState<RegisteredCompany[]>([]);
  const { data, fetchNextPage } = useCompanySearchQuery(debouncedSearchString);

  useEffect(() => {
    const results = data?.pages.flat(1);
    if (results) {
      setResults(results);
    }
  }, [data?.pages]);

  // Stop loading if search string did not impact search
  useEffect(() => {
    if (searchString === debouncedSearchString) {
      setResults([...results]);
    }
  }, [searchString]);

  const currentPage = data?.pageParams.length || 1;
  const showMore = () => fetchNextPage({ pageParam: currentPage + 1 });

  return { results, showMore };
};
